'use client';

import Script from 'next/script';
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { usePrivacyConsent } from '~/lib/privacy/context.client';
import { shouldLoadThirdPartyScripts } from '~/lib/privacy/model';

interface Props {}

const TrustpilotFooter: React.FC<Props> = () => {
  const privacyConsent = usePrivacyConsent();
  const [shouldLoad, setShouldLoad] = useState(false);
  const intersectionRef = useRef<HTMLDivElement>(null);

  // @ts-expect-error
  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '300px',
    threshold: 0.1,
  });

  useEffect(() => {
    if (intersection?.isIntersecting && !shouldLoad) {
      setShouldLoad(true);
    }
  }, [intersection?.isIntersecting, shouldLoad]);

  return (
    <>
      <div
        ref={intersectionRef}
        className="trustpilot-widget my-8 text-center"
        data-locale="en-US"
        data-template-id="5419b637fa0340045cd0c936"
        data-businessunit-id="55d25dce0000ff000582430a"
        data-style-height="20px"
        data-style-width="100%"
        data-theme="dark"
      >
        <a
          href="https://www.trustpilot.com/review/sidelineswap.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div>

      {shouldLoad && shouldLoadThirdPartyScripts(privacyConsent.state) && (
        <Script
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          strategy="lazyOnload"
        />
      )}
    </>
  );
};

export default TrustpilotFooter;
